export const LOAD_USER_ATTRIBUTES_STARTED = "LOAD_USER_ATTRIBUTES_STARTED";
export const LOAD_USER_ATTRIBUTES_RETURNED = "LOAD_USER_ATTRIBUTES_RETURNED";
export const LOAD_USER_ATTRIBUTES_FAILED = "LOAD_USER_ATTRIBUTES_FAILED";
export const LOGOUT_USER = "LOGOUT_USER";
